import { useParams } from 'react-router';
import { usePermissions } from '@/entities/user';
import { useFolders } from '@/features/guidelines/hooks';
import { ROUTES } from '@/shared/config/routes';
import type { UseGuidelinesWorkspaceReturn } from './useGuidelinesWorkspace.types';

/**
 * Folder list and derived selection for the workspace shell. Selection comes
 * straight from the URL, never synced into local state, so there is nothing
 * to reset when the route changes. The create action itself (opening
 * `FolderFormSheet`) is owned by `GuidelinesWorkspace`, which also owns that
 * sheet's open/mode/folder state — this hook only reports whether the
 * action is permitted.
 */
export function useGuidelinesWorkspace(): UseGuidelinesWorkspaceReturn {
  const { folderId } = useParams<{ folderId: string }>();
  const { canManageBrandVisualGuidelines } = usePermissions();
  const { data: folders, status } = useFolders();

  return {
    folders: folders ?? [],
    isLoadingFolders: status === 'pending',
    activeFolderId: folderId ?? null,
    canCreate: canManageBrandVisualGuidelines,
    hrefFor: (id) => ROUTES.KNOWLEDGE_HUB_VISUAL_GUIDELINES_FOLDER(id),
  };
}
